export default {"src":"/_next/static/media/quote.01fa3eb5.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};